import { useState, useEffect, useRef } from "react";
const features = [{
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/62-ortodoncia-invisible-e1492721258898.jpg",
  alt: "Virtualmente Invisible",
  heading: "Virtualmente Invisible",
  body: "Los alineadores Rio son fabricados en un material 100 % transparente, garantizando así que usted pueda sonreír libremente.",
  number: "01"
}, {
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/64-ortodoncia-invisible-e1492721344277.jpg",
  alt: "Confortables",
  heading: "Confortables",
  body: "Comparado con los brackets tradicionales los alineadores Rio son mucho más cómodos de llevar y no maltratan las mejillas.",
  number: "02"
}, {
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/21-ortodoncia-bogota-e1492721457331.jpg",
  alt: "Sin Alambres",
  heading: "Sin Alambres",
  body: "Olvídese para siempre de mostrar sus alambres cada vez que sonríe, los alineadores Rio son totalmente transparentes.",
  number: "03"
}];
export default function IntroFeatures() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [itemsVisible, setItemsVisible] = useState<boolean[]>([false, false, false]);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observers = itemRefs.current.map((el, i) => {
      if (!el) return null;
      const obs = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setItemsVisible(prev => {
            const next = [...prev];
            next[i] = true;
            return next;
          });
        }
      }, {
        threshold: 0.2
      });
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach(o => o && o.disconnect());
  }, []);
  return <section ref={sectionRef} className="bg-background text-foreground overflow-hidden">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=DM+Sans:wght@300;400;500&display=swap');`}</style>

      <div className="relative">
        <div className="absolute inset-0 pointer-events-none" style={{
        background: "linear-gradient(135deg, #e8f4f0 0%, #f9fffe 50%, #eaf6fb 100%)"
      }} />

        <div className={`relative max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10 transition-all duration-1000 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex flex-col md:flex-row md:items-end md:gap-16">
            <div className="md:w-2/3">
              <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4 px-3 py-1 rounded-full border !text-[rgba(8,215,247,1)]" style={{
              fontFamily: "'DM Sans', sans-serif",
              color: "#2a9d8f",
              borderColor: "#2a9d8f44",
              backgroundColor: "#2a9d8f11"
            }}>
                Ortodoncia Invisible
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight font-bold mb-0" style={{
              fontFamily: "'Playfair Display', serif",
              color: "#1a2e2b"
            }}>
                Laboratorio que
                <br />
                <em className="not-italic !text-[rgba(8,215,247,1)]" style={{
                color: "#2a9d8f"
              }}>Revoluciona</em> la
                <br />
                Ortodoncia en Colombia
              </h1>
            </div>
            <div className="md:w-1/3 mt-6 md:mt-0 md:pb-2">
              <p className="text-base md:text-lg leading-relaxed" style={{
              fontFamily: "'DM Sans', sans-serif",
              color: "#4a6b65"
            }}>
                Es el nuevo sistema de ortodoncia con Alineadores Transparentes que deja atrás los brackets y se impone a nivel mundial como la tecnología más revolucionaria en Ortodoncia Invisible
              </p>
            </div>
          </div>

          <div className="mt-10 w-full h-px" style={{
          background: "linear-gradient(to right, #2a9d8f33, #2a9d8f99, #2a9d8f33)"
        }} />
        </div>
      </div>

      <div className="relative" style={{
      background: "linear-gradient(135deg, #e8f4f0 0%, #f9fffe 50%, #eaf6fb 100%)"
    }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 pb-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
            {features.map((feature, i) => <div key={i} ref={el => {
            itemRefs.current[i] = el;
          }} className={`relative group transition-all duration-700 ease-out ${itemsVisible[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <div className="relative h-full border-t-0 md:border-t border-r-0 md:border-r last:border-r-0 border-b border-l-0 md:border-l" style={{
              borderColor: "#2a9d8f22"
            }}>
                  <div className="px-0 md:px-8 pt-8 pb-10">
                    <div className="flex items-start gap-4 mb-6">
                      <span className="text-6xl font-bold leading-none select-none" style={{
                    fontFamily: "'Playfair Display', serif",
                    color: "#2a9d8f18"
                  }}>
                        {feature.number}
                      </span>
                      <div className="mt-1 flex-shrink-0 w-1 self-stretch rounded-full" style={{
                    background: "linear-gradient(to bottom, #2a9d8f, #2a9d8f33)"
                  }} />
                    </div>

                    <div className="relative overflow-hidden rounded-2xl mb-6 group-hover:shadow-lg transition-shadow duration-500" style={{
                  background: "#ffffff"
                }}>
                      <img src={feature.image} alt={feature.alt} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" style={{
                    aspectRatio: "1/1",
                    objectFit: "cover"
                  }} />
                      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{
                    background: "linear-gradient(to top, #2a9d8faa 0%, transparent 60%)"
                  }} />
                    </div>

                    <h2 className="text-2xl font-bold mb-3" style={{
                  fontFamily: "'Playfair Display', serif",
                  color: "#1a2e2b"
                }}>
                      {feature.heading}
                    </h2>
                    <p className="text-sm md:text-base leading-relaxed" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  color: "#4a6b65"
                }}>
                      {feature.body}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        <div className={`relative max-w-7xl mx-auto px-6 md:px-12 pb-20 transition-all duration-1000 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionDelay: "600ms"
      }}>
          <div className="rounded-3xl overflow-hidden p-8 flex flex-col gap-8 md:p-12 md:flex-row md:items-center md:gap-16" style={{
          background: "linear-gradient(135deg, #1a2e2b 0%, #2a4a44 100%)"
        }}>
            <div className="md:w-1/2">
              <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase mb-4 px-3 py-1 rounded-full !text-[rgba(8,215,247,1)]" style={{
              fontFamily: "'DM Sans', sans-serif",
              color: "#7ed8cc",
              backgroundColor: "#2a9d8f33"
            }}>
                Ventajas
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" style={{
              fontFamily: "'Playfair Display', serif"
            }}>
                Ventajas
              </h2>
            </div>
            <div className="md:w-1/2">
              <p className="text-base md:text-lg leading-relaxed mb-6" style={{
              fontFamily: "'DM Sans', sans-serif",
              color: "#b2d8d3"
            }}>
                Son innumerables las ventajas del sistema Rio3D, de las cuales se destacan su insuperable comodidad de uso, verdaderamente higiénicos y fácilmente Monitoreados desde cualquier lugar donde se encuentre el paciente a través de su smartphone.
              </p>
              <div className="inline-flex items-center gap-3 px-5 py-3 rounded-2xl" style={{
              background: "#2a9d8f22",
              border: "1px solid #2a9d8f55"
            }}>
                <div className="w-2 h-2 rounded-full flex-shrink-0" style={{
                background: "#7ed8cc"
              }} />
                <span className="text-sm font-medium !text-[rgba(8,215,247,1)]" style={{
                fontFamily: "'DM Sans', sans-serif",
                color: "#7ed8cc"
              }}>
                  Removibles — Los alineadores removibles Rio se pueden quitar para cepillar los dientes
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}